import { namespacer } from 'helpers'

const namespace = namespacer('ERRORS')

export const UNHANDLED_ERROR = namespace('UNHANDLED_ERROR')
export const DISMISS_UNHANDLED_ERROR = namespace('DISMISS_UNHANDLED_ERROR')
